//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../CAE/CAE.CaeSession.js";
let d=[[],[[["strainData","stressData","youngsModulus","poissionRatio","inputDataType","outputDataType","numDataPtsOut","convertedStrainData","convertedStressData"],"ConvertStressStrainData",{},6,1],[["strainData","stressData","youngsModulus","poissionRatio","inputDataType","outputDataType","numDataPtsOut","convertedStrainData","convertedStressData","convertedYoungsModulus"],"ConvertStressStrainYoungsModulusData",{},6,0],[["iacsData","numDataPtsOut","electricalConductivityData"],"ConvertIacspercentToElectricalConductivity",{},1,0],[["electricalConductivityData","numDataPtsOut","iacsData"],"ConvertElectricalConductivityToIacspercent",{},1,0]],[]];
SPLM.MaterialUtilities = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.MaterialUtilities";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MaterialUtilities.StressStrainData = Object.freeze({
    "EngineeringStressEngineeringStrain" : "EngineeringStressEngineeringStrain", "EngineeringStressEngineeringPlasticStrain" : "EngineeringStressEngineeringPlasticStrain", "TrueStressLogStrain" : "TrueStressLogStrain", "TrueStressLogPlasticStrain" : "TrueStressLogPlasticStrain", "Undefined" : "Undefined"});

export default SPLM;